<template>
	<div>
		<DataInputMenuAbsoluteMenuWrapper v-model="showMenuFlag" v-bind="absoluteMenuProps">
			<DataInputMenu
				@re-calc-menu-position="reCalcMenuPosition"
				:localValue="localValue"
				:tabItems="tabItems"
				:tab.sync="localTab"
				:curTabCode="curTabCode"
				isMultipleOnly
				:valuesTypes="allowedValuesTypes"
				@close="showMenuFlag = false"
				v-on="inputMenuListeners"
				:showMenuFlag="showMenuFlag"
				:param="param"
				:fieldParams="items"
				:allowMultipleSelection="allowMultipleSelection"
				ref="data_input_menu"
				:didOpenBySlash="didOpenBySlash"
				:isBottomToTopLayout="isBottomToTopLayout"
			/>
		</DataInputMenuAbsoluteMenuWrapper>
	</div>
</template>

<script>
import DataInputMenu from '../../../../DataInput/DataInputMenu/DataInputMenu';
import { DATA_INPUT_MENU_ALLOWED_VALUES } from '../../../../DataInput/DataInputMenu/helpers/data-input-menu.const';
import DataInputMenuMixin from '../mixins/DataInputMenuMixin';
export default {
	name: 'ListSourceDataInputMenu',
	mixins: [DataInputMenuMixin],
	props: {
		param: { type: Object },
	},
	components: { DataInputMenu },
	computed: {
		curTabCode() {
			return this.dataInputMenuProps.curTabCode;
		},
		allowedValuesTypes() {
			return [DATA_INPUT_MENU_ALLOWED_VALUES.TABLE];
		},
		items() {
			return this.dataInputMenuProps.items;
		},
	},
};
</script>

<style lang="scss" scoped></style>
